import type { Color } from "../colors/Color"

export type ColorMap = Record<string, Color>
